import { css } from 'styled-components';

export const backgroundGradient = css`
  background: radial-gradient(
    circle closest-side at center,
    ${({ theme }) => theme.gradients.gradient01.from},
    ${({ theme }) => theme.gradients.gradient01.to}
  );
`;
